import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomDropdown from '@components/CustomDropdown';

import { setFilters } from '@store/common/action';
import { getCommonFilters } from '@store/reducers';

const CommonSelectFilter = ({
	nameWithSpace,
	title,
	type,
	isMulti,
	firstType,
	secondType,
	firstTypeData,
	secondTypeData,
	callBack
}) => {
	const dispatch = useDispatch();
	const commonfilters = useSelector(getCommonFilters);

	const onChange = (e) => {
		dispatch(setFilters({ ...commonfilters, [type]: e.target.value }));
	};

	const selected = (type) => {
		return commonfilters[type];
	};

	const selectedFirstType = (firstType) => {
		return commonfilters[firstType];
	};

	const onItemClick = (item) => {
		if (item?.title === 'Country') {
			dispatch(
				setFilters({
					...commonfilters,
					[firstType]: item.id,
					[`${firstType}_value`]: item.value
				})
			);
			callBack(item.id);
		}
		if (item?.title === 'City') {
			dispatch(
				setFilters({
					...commonfilters,
					[secondType]: item.id,
					[`${secondType}_value`]: item.value
				})
			);
		}
	};

	return (
		<div className="filter-content">
			<div id="accordion">
				{isMulti ? (
					<div className="card locationCard">
						<div className="card-header" id="headingLocation">
							<h5 className="mb-0">
								<button
									className="btn btn-link collapsed"
									data-toggle="collapse"
									data-target={`#${title}`}
									aria-expanded="true"
									aria-controls={`${title}`}
								>
									{nameWithSpace ? nameWithSpace : title}
								</button>
							</h5>
						</div>
						<div id={`${title}`} className="collapse" aria-labelledby="headingBrand">
							<div className="card-body">
								<div className="container range-input pt-2 px-0">
									<div className="row">
										<div className="col-md-6 pr-1">
											<div className="form-group mb-0">
												<CustomDropdown
													type="addItem"
													title={'Country'}
													onItemClick={onItemClick}
													items={firstTypeData.map((item) => ({
														id: item.id,
														value: item.name,
														key: item.name
													}))}
													selectedItem={selectedFirstType(`${firstType}_value`)}
												/>
											</div>
										</div>
										<div className="col-md-6 pl-1">
											<div className="form-group mb-0">
												<CustomDropdown
													type="addItem"
													title={'City'}
													onItemClick={onItemClick}
													items={secondTypeData.map((item) => ({
														id: item.id,
														value: item.name,
														key: item.name
													}))}
													selectedItem={selectedFirstType(`${secondType}_value`)}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="card">
						<div className="card-header" id="headingBrand">
							<h5 className="mb-0">
								<button
									className="btn btn-link collapsed"
									data-toggle="collapse"
									data-target={`#${title}`}
									aria-expanded="true"
									aria-controls={`${title}`}
								>
									{nameWithSpace ? nameWithSpace : title}
								</button>
							</h5>
						</div>
						<div id={`${title}`} className="collapse" aria-labelledby="headingBrand">
							<div className="card-body">
								<div className="container range-input pt-2 px-0">
									<div className="row">
										<div className="col-md-12 pr-1">
											<div className="form-group mb-0">
												<select
													className="w-100"
													name="rating"
													id="rating"
													value={selected(type)}
													onChange={(e) => onChange(e)}
												>
													<option value={''}>Select</option>
													<option value={1}>1</option>
													<option value={2}>2</option>
													<option value={3}>3</option>
													<option value={4}>4</option>
													<option value={5}>5</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default CommonSelectFilter;
